import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.baseURL =
    process.env.NODE_ENV === 'production' ? 'https://psapi.partnerselect.net' : 'http://localhost:3000';

export default axios;
